//import React, { useEffect, useState } from "react";
import { useEffect, useState } from "react";
import Home from "./Home";
import { operations as searchOperations } from "../../redux/SearchResult";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

/*Note 20240513 Home-container seems to call ..\searchResultSaga\saga.js twice,
so enth is called twice.  Search request from \result on execute once.*/
const HomeContainer = () => {
  let dispatch = useDispatch();
  let suggestions = [
    "Al Kaline",
    "Cobb sb",
    "Who hit the most dingers in 1980?",
    "AAPL",
    "ein is 460636374",
  ];

  const [searchInput, setSearchInput] = useState("");
  const dispatchSearch = searchOperations.dispatchSearch(dispatch);
  let navigate = useNavigate();

  const clickSuggestion = (value) => {
    //set the search criteria
    dispatchSearch(value);
    //route to result
    navigate("/result");
  };

  useEffect(()=> {
    setSearchInput('');
    //reset the search criteria
    dispatchSearch('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const handleSearch = () => {
    if (searchInput?.trim()) {
      //set the search criteria
      dispatchSearch(searchInput);
      //route to result
      navigate("/result");
    }
  };

  function handleEnter(event) {
    if (event.keyCode === 13) {
      if (searchInput?.trim()) {
        //set the search criteria
        dispatchSearch(searchInput);
        //route to result
        navigate("/result");
      }
    }
  }

  const handleChange = (e) => {
    setSearchInput(e.target.value);
  };

  return (
    <Home
      suggestionsData={suggestions}
      searchInput={searchInput}
      clickSuggestion={clickSuggestion}
      handleSearch={handleSearch}
      handleChange={handleChange}
      handleEnter={handleEnter}
    />
  );
};

export default HomeContainer;
